import React, { useContext, useEffect, useState, useMemo } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Row, Col, Card, Table, Modal, Button, Tab, Nav, Spinner } from "react-bootstrap";
import Moment from 'react-moment';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import { getReportEmployeeList, } from '../../../store/actions/EmployeeActions';
import { getOwnLeaveCalenderListData, getLeaveTypeData } from '../../../store/actions/LeaveAction';
import { supervisorApprovalReportDetails, updateClientReportStatusDetails, reportSendBackDetails, getreportDrillData, getPendingCountData, getPeportProgressData, getFilterGeneratedReportData } from '../../../store/actions/TimeCardActions';
import { getNoteData, addNoteData } from '../../../store/actions/TimeCaptureActions';
import { globalLoadingAction } from '../../../store/actions/GlobalAction';
import GenerateTimeCard from "../Components/GenerateTimeCard";
import RightSideModal from '../Components/RightModal';
import ProgressReport from "../Components/ProgressReport";
import ReactPaginate from "react-paginate";
import LeaveCardView from "../Components/LeaveCardView";

const SuperVisorApprover = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const [activeTab, setActiveTab] = useState(1);
    const [reportType, setReportType] = useState(null);
    const [cardNonList, setCardNonList] = useState([]);
    const [cardList, setCardList] = useState([]);
    const [addModal, setAddModal] = useState(false);
    const [timeModal, setTimeModal] = useState(false);
    const [loadingStatus, setLoadingStatus] = useState(null);
    //note
    const [message, setMessage] = useState('');
    const [projectId, setProjectId] = useState(null);
    const [reportId, setReportId] = useState(null);
    const [status, setStatus] = useState(null);
    const [noteData, setNoteData] = useState([]);
    const [isNote, setIsNote] = useState(false);
    const [loading, setLoading] = useState(false);
    const [details, setDetails] = useState(null);
    const [commentModal, setCommentModal] = useState(false);
    const [comment, setComment] = useState('');
    const [weeklyOff, setWeeklyOff] = useState(false);
    const [isComment, setIsComment] = useState(false);
    const [userId, setUserId] = useState('');
    const [textComment, setTextComment] = useState('');
    const [errorComment, setErrorComment] = useState('');
    const [captureType, setCaptureType] = useState('0');
    const [reportFilterLoading, setReportFilterLoading] = useState(false);
    const [calenderDate, setCalenderDate] = useState(null);
    const [isText, setIsText] = useState(false);
    const [itemDetails, setItemDetails] = useState('');
    const [projectName, setProjectName] = useState('');
    //filter
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [empId, setEmpId] = useState('');
    const [drill, setDrill] = useState({
        perPage: 10,
        page: 1,
        date: '',
        projectId: '',
        generateBy: ''
    });

    const getReportDetails = () => {
        dispatch(globalLoadingAction(true));
        dispatch(supervisorApprovalReportDetails(empId, page, perPage, props.history));
        dispatch(getReportEmployeeList(props.history));
        dispatch(getPendingCountData(props.history));
        dispatch(getLeaveTypeData(props.history));
        //dispatch(getOwnLeaveCalenderListData(props.userId, '', props.history));
    }

    useEffect(() => {
        getReportDetails();
    }, []);


    const onSubmitMessageHandler = () => {
        setMessage("");
        setLoading(true);
        dispatch(addNoteData(projectId, message, AddNotData, props.history));
    }
    const AddNotData = (data) => {
        setNoteData(data);
        setLoading(false);
    }

    const onGetNoteHandler = (task_id) => {
        setProjectId(task_id);
        dispatch(globalLoadingAction(true));
        dispatch(getNoteData(task_id, setNotData, props.history));
    }

    const setNotData = (data) => {
        dispatch(globalLoadingAction(false));
        setNoteData(data);
        setIsNote(true);
    }

    const closeHandler = () => {
        setIsNote(false);
        setNoteData([]);
    }

    const onViewHalder = (item) => {
        if (item) {
            let array = JSON.parse(item.report_data);
            if (item.track_type == 0) {
                let array2 = JSON.parse(item.non_billable_report_data);
                setCardNonList(array2 ?? []);
            }
            setStatus(item.status);
            setCalenderDate(new Date(moment(item.start_date).toDate()));
            setReportId(item._id);
            setProjectName(item.project_name);
            // setAddModal(true);
            setCardList(array ?? []);
            setDetails(item);
            setReportType(item.track_type);
            setWeeklyOff(item.weekly_off);
            setCaptureType('0');
            setUserId(item?.generate_by);
            dispatch(getPeportProgressData(item._id, item.project_id, progressCallBack, props.history));
            dispatch(getOwnLeaveCalenderListData(item.generate_by, '', props.history));
        }
    }

    const progressCallBack = () => {
        setAddModal(true);
        setComment('');
        setErrorComment('');
    }

    const updateCallBack = () => {
        const timer = setTimeout(() => {
            setReportId(null);
            setStatus(null);
            setAddModal(false);
            setLoading(false);
            setCardList([]);
            setLoadingStatus(null);
            getReportDetails();
            // dispatch(getPendingCountAction({ count: props.pendingCount - 1 }));
            dispatch(getPendingCountData(props.history));
            setComment('');
            setCommentModal(false);

        }, 1000);

        // Return a cleanup function
        return () => clearTimeout(timer);
    };

    const onStatusHandler = (status) => {
        setErrorComment('');
        setLoading(true);
        setLoadingStatus(status);
        dispatch(updateClientReportStatusDetails(reportId, status, comment, updateCallBack, history));
    }
    const onSendBackHandler = (status) => {
        if (comment == '') {
            setErrorComment('Comment is Required')
            return
        }
        setErrorComment('');
        setLoading(true);
        setLoadingStatus(1);
        dispatch(reportSendBackDetails(reportId, status, comment, updateCallBack, history));
    }



    const onChangeHandler = (index, value, parentIndex, childIndex) => {
        const updatedData = [...cardList];
        const time = value ? parseInt(value, 10) : 0; // Parse input as integer

        // Update the specific working hourF
        updatedData[index].data_table[parentIndex].time_details[childIndex].working_hour = time;

        // Calculate total hours for the current row
        const totalRowHours = updatedData[index].data_table[parentIndex].time_details.reduce(
            (acc, element) => acc + element.working_hour,
            0
        );
        updatedData[index].data_table[parentIndex].total_hour = totalRowHours;

        // Calculate the overall total hours
        const overallTotalHours = updatedData[index].data_table.reduce(
            (acc, row) => acc + row.total_hour,
            0
        );
        updatedData[index].total_hour = overallTotalHours;
        setCardList(updatedData);
    };

    const onChangeRateHandler = (index, value) => {
        const updatedData = [...cardList]; // Create a shallow copy of data
        const rate = value ? parseInt(value, 10) : 0;
        updatedData[index].emp_rate = rate;
        setCardList(updatedData);
    }

    const handleTabSelect = (key) => {
        setActiveTab(Number(key));
    };

    const onFilterEmpHandler = (id) => {
        dispatch(globalLoadingAction(true));
        dispatch(supervisorApprovalReportDetails(id, 1, perPage, props.history));
        setPage(1);
        setEmpId(id);
    }

    const tabData = [
        {
            id: 1,
            name: "Billable",
            content: <>{cardList.map((item, index) => {
                return (
                    <GenerateTimeCard
                        key={index}
                        //changeHandler={() => { }}
                        //changeRateHandler={() => { }}
                        note={false}
                        isEdit={false}
                        isConfig={weeklyOff}
                        isLink={true}
                        projectName={projectName}
                        getTimeDetails={(weeksIndex, timeIndex, task_id) => onTimeDetails(task_id, index, weeksIndex, timeIndex, 0)}
                        details={item} />
                )
            })}</>,
        },
        {
            id: 2,
            name: "Non-billable",
            content: <>{cardNonList.map((item, index) => {
                return (
                    <GenerateTimeCard
                        key={index}
                        //changeHandler={() => { }}
                        //changeRateHandler={() => { }}
                        note={false}
                        isEdit={false}
                        isConfig={weeklyOff}
                        isLink={true}
                        projectName={projectName}
                        getTimeDetails={(weeksIndex, timeIndex, task_id) => onTimeDetails(task_id, index, weeksIndex, timeIndex, 1)}
                        details={item} />
                )
            })}</>,
        }
    ];

    const handleCartPageClick = (data) => {
        dispatch(globalLoadingAction(true));
        dispatch(supervisorApprovalReportDetails(empId, data.selected + 1, perPage, props.history));
        setPage(data.selected + 1);
    }

    const onResetHandler = () => {
        dispatch(globalLoadingAction(true));
        dispatch(supervisorApprovalReportDetails('', 1, perPage, props.history));
        setPage(1);
        setEmpId('');
    }

    const onTimeDetails = (task_id, index, weeksIndex, timeIndex, type) => {

        let date;
        if (type == 1) {
            date = cardNonList[index].weeks_table[weeksIndex].time_table[timeIndex].date; // Example: "Jan 1"
        } else {
            date = cardList[index].weeks_table[weeksIndex].time_table[timeIndex].date; // Example: "Jan 1"
        }

        let startDate = details.start_date; // "2024-12-02"
        let endDate = details.end_date; // "2025-01-01"

        // Extract years
        let startYear = startDate.split("-")[0]; // "2024"
        let endYear = endDate.split("-")[0]; // "2025"
        // Extract start month
        let startMonth = startDate.split("-")[1]; // "12" (December)
        // Month mapping
        const monthMap = {
            "Jan": "01",
            "Feb": "02",
            "Mar": "03",
            "Apr": "04",
            "May": "05",
            "Jun": "06",
            "Jul": "07",
            "Aug": "08",
            "Sep": "09",
            "Oct": "10",
            "Nov": "11",
            "Dec": "12",
        };

        // Split "Jan 1" into month and day
        let [monthAbbr, day] = date.split(" ");
        let month = monthMap[monthAbbr]; // Convert "Jan" -> "01"

        // Ensure day is always two digits (e.g., "01" instead of "1")
        day = day.padStart(2, "0");

        // Determine the correct year
        //let year = (month === "01") ? endYear : startYear; // Jan -> endYear, Dec -> startYear
        let year = (month < startMonth) ? endYear : startYear;
        // Construct final date string
        let output = `${year}-${month}-${day}`;

        dispatch(getreportDrillData(task_id, details.generate_by, output, 1, drill.perPage, trackCallBack, props.history));
        setDrill({ ...drill, date: output, projectId: task_id, generateBy: details.generate_by, page: 1 });
    };

    const trackCallBack = () => {
        setTimeModal(true);
    }

    const handlePageClick = (data) => {
        dispatch(getreportDrillData(drill.projectId, drill.generateBy, drill.date, data.selected + 1, drill.perPage, {}, props.history));
        setDrill({ ...drill, page: data.selected + 1 });
    };

    const onCommentHandler = (value) => {
        setTextComment(value);
        setIsComment(true);
    }

    const onTextCommantdHandler = (value) => {
        setIsText(true);
        setItemDetails(value)
    }

    const onFilterGeneratedReport = (val) => {
        setCaptureType(val);
        setReportFilterLoading(true);
        dispatch(getFilterGeneratedReportData(reportId, parseInt(val), filterDataCallBack, props.history));
    }

    const filterDataCallBack = (item) => {
        setReportFilterLoading(false);
        if (reportType == 0) {
            setCardNonList(item?.data?.non_billable_report_data);
            setCardList(item?.data?.report_data);
        } else {
            setCardList(item?.data);
        }

        setWeeklyOff(item.weekly_off);
    }


    const leaveCardProps = useMemo(() => {

        const getTotalHour = (element) =>
            Number(element?.total_hour) || 0;
        const billedTotal = cardList.reduce((sum, el) => sum + getTotalHour(el), 0);
        const unbilledTotal = cardNonList.reduce((sum, el) => sum + getTotalHour(el), 0);
        const cardTotal = cardList.reduce((sum, el) => sum + getTotalHour(el), 0);

        const totalHour = details?.track_type == 0
            ? (activeTab == 1 ? billedTotal : unbilledTotal)
            : cardTotal;

        return {
            userId: details?.generate_by,
            filterType: 3,
            startDate: details?.start_date,
            endDate: details?.end_date,
            isAddLeave: false,
            grandHour: totalHour ?? 0,
        };
    }, [details, cardNonList, cardList, activeTab]);

    return (
        <>
            <div className="row">

                <div className="breadcrumb-container">
                    <ul>
                        <li>
                            <Link to={"#"}>Report Approval</Link>
                        </li>
                        {/* <li><i className="fa fa-angle-right"></i></li>
                        <li>
                            <Link to={"#"}>Generated Report</Link>
                        </li> */}
                    </ul>
                </div>

                <div className="title-body-container">
                    <div className="title-body mb-3">
                        <h3>Report</h3>
                    </div>
                    <div className="title-filter-container">
                        <div className="form-group single-filter-select me-2">
                            <div className="select-drop-down">
                                <span><i class="fa fa-angle-down"></i></span>
                                <select
                                    defaultValue={"option"}
                                    className="form-control select-control"
                                    value={empId}
                                    onChange={(e) => onFilterEmpHandler(e.target.value)}
                                >
                                    <option value="">Select Employee</option>
                                    {
                                        props.employeeList.map((item, index) => {
                                            return <option key={index} value={item.user_id}>{item.first_name + " " + item.last_name}</option>
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                        <button
                            className="reset_filter-btn me-0"
                            onClick={() => onResetHandler()}
                            disabled={!empId}
                        >Reset</button>
                    </div>
                </div>
                <div className="account-setting-content">
                    <Col lg={12}>
                        <Card className='m-0'>
                            <Card.Body>
                                {props.screenVisible ?
                                    <>
                                        {props.timeCardDetails.length > 0 ?
                                            <>
                                                <Table responsive>
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                <strong>ID</strong>
                                                            </th>
                                                            <th>
                                                                <strong>Client Name</strong>
                                                            </th>
                                                            <th>
                                                                <strong>Name</strong>
                                                            </th>
                                                            {/* <th>
                                                                <strong>Project ID</strong>
                                                            </th> */}
                                                            <th>
                                                                <strong>Report Type</strong>
                                                            </th>
                                                            <th>
                                                                <strong>Period End Date</strong>
                                                            </th>
                                                            <th>
                                                                <strong>Comment</strong>
                                                            </th>
                                                            <th>
                                                                <strong>Status</strong>
                                                            </th>
                                                            <th>
                                                                <strong>Actions</strong>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            props.timeCardDetails.map((item, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td>{item.bill_id}</td>
                                                                        <td>{item.client_first_name} {item.client_last_name}</td>
                                                                        <td>{item.send_by_first_name} {item.send_by_last_name}</td>
                                                                        {/* <td>{item.project_id}</td> */}
                                                                        <td>
                                                                            {(() => {
                                                                                switch (item.track_type) {
                                                                                    case 1:
                                                                                        return "Billable"
                                                                                    case 2:
                                                                                        return "Non-billable"
                                                                                    default:
                                                                                        return "All"
                                                                                }
                                                                            })()}
                                                                        </td>
                                                                        <td><Moment format="D MMM YYYY" withTitle>{item.end_date}</Moment></td>
                                                                        {/* <td><Moment format="D MMM YYYY" withTitle>{item.start_date}</Moment> to <Moment format="D MMM YYYY" withTitle>{item.end_date}</Moment></td> */}
                                                                        <td>
                                                                            <button
                                                                                type="button"
                                                                                disabled={item.send_back_msg ? false : true}
                                                                                onClick={() => onTextCommantdHandler(item.send_back_msg)}
                                                                                className="btn btn-info btn-xs sharp btn-black"
                                                                            >
                                                                                <i className="fa fa-commenting" aria-hidden="true"></i>
                                                                            </button>

                                                                        </td>
                                                                        <td>
                                                                            <div className="d-flex">
                                                                                {(() => {
                                                                                    switch (item.status) {
                                                                                        case 1:
                                                                                            return (
                                                                                                <p class="text-warning fw-bold">Pending</p>
                                                                                            );
                                                                                        case 5:
                                                                                            return (
                                                                                                <p class="text-success fw-bold">Approved</p>
                                                                                            );
                                                                                        default:
                                                                                            return (
                                                                                                <p class="text-secondary fw-bold">Under process</p>
                                                                                            );
                                                                                    }
                                                                                })()}
                                                                            </div>

                                                                        </td>
                                                                        <td>
                                                                            <div className="d-flex">
                                                                                <button
                                                                                    onClick={() => onViewHalder(item)}
                                                                                    className="btn btn-info shadow btn-xs"
                                                                                >Details
                                                                                </button>

                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        }
                                                    </tbody>
                                                </Table>
                                            </>
                                            :
                                            <div className="nodata-found-view">
                                                <h2>Data not found</h2>
                                                <p>Report data is empty or Try again search</p>
                                                <button type="button"
                                                //onClick={onCleanHandler}
                                                >
                                                    Retry
                                                </button>
                                            </div>
                                        }
                                        <div className="pagination-container">
                                            {parseInt(props.totalRecord) > 0 && props.showLoading == false ? (
                                                <div className="page-result alignResult">
                                                    <p>Showing{" "}{(page - 1) * perPage + 1 + " - " + ((page - 1) * perPage + props.timeCardDetails.length) + " of " + "( " + props.totalRecord + " items )"}</p>
                                                </div>
                                            ) : (
                                                <div></div>
                                            )}

                                            {parseInt(props.totalRecord) > perPage ? (
                                                <ReactPaginate
                                                    containerClassName="pagination-gutter false pagination-circle pagination"
                                                    pageClassName="page-item"
                                                    pageLinkClassName="page-link"
                                                    breakLabel="..."
                                                    nextLabel={<i class="fa fa-angle-right" aria-hidden="true"></i>}
                                                    nextClassName="page-item"
                                                    nextLinkClassName="page-link"
                                                    previousLabel={<i class="fa fa-angle-left" aria-hidden="true"></i>}
                                                    previousClassName="page-item"
                                                    previousLinkClassName="page-link"
                                                    breakClassName="page-item"
                                                    breakLinkClassName="page-link"
                                                    renderOnZeroPageCount={null}
                                                    activeClassName="active"
                                                    onPageChange={handleCartPageClick}
                                                    pageRangeDisplayed={3}
                                                    pageCount={props.totalPage}
                                                    //initialPage={active - 1}
                                                    forcePage={page - 1}
                                                />
                                            ) : null}
                                        </div>
                                    </>
                                    : null}
                            </Card.Body>
                        </Card>
                        <div>
                            <p><strong>Note:</strong> Use increments of 0.25 (15 minutes) when recording hours.</p>
                        </div>
                    </Col>
                </div>
            </div>

            <Modal
                className="fade bd-example-modal-sm"
                size="xl"
                show={addModal}
                onHide={() => setAddModal(false)}
                centered
            >
                {reportFilterLoading ?
                    <div className='report-loder-container'>
                        <div className='report-loder'>
                            <Spinner
                                as="span"
                                animation="border"
                                size="lg"
                                role="status"
                                aria-hidden="true"
                                variant="success"
                            /></div>
                    </div> : null}
                <Modal.Header closeButton>
                    <Modal.Title><h2>Time Report</h2></Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    {cardList.length > 0 ?
                        <>
                            <div className="card-detail-header">

                                <div className="card-detail-left">
                                    {/* <div>
                                        <h4 className='mb-2'><strong>Project ID:</strong> {details?.project_id}</h4>
                                    </div> */}
                                    <div>
                                        <h4 className='mb-2'><strong>ID:</strong> {details?.bill_id}</h4>
                                    </div>
                                    <div>
                                        <h4 className='mb-2'><strong>Person Name:</strong> {details?.employee_first_name} {details?.employee_last_name} <button className='view-details-btn' onClick={() => setIsComment(true)}><i class="bi bi-eye"></i></button></h4>
                                    </div>
                                    <div>
                                        <h4 className='mb-2'><strong>Period End Date:</strong> <Moment format="D MMM YYYY" withTitle>{details?.end_date}</Moment></h4>
                                    </div>
                                </div>
                                {/* <div className="card-detail-right">
                                    <button className='view-user-details-btn' onClick={() => setIsComment(true)}>View Details</button>
                                </div> */}
                                {/* <div className="card-detail-right"> */}
                                {/* <div>
                                        <h4 className='mb-2'><strong>Employee ID:</strong> {details?.employee_id}</h4>
                                    </div> */}
                                {/* <div>
                                        <h4 className='mb-2'><strong>Person Name:</strong> {details?.employee_first_name} {details?.employee_last_name}</h4>
                                    </div> */}
                                {/* <div>
                                        <h4 className='mb-b'><strong>Employee Email:</strong> {details?.employee_email}</h4>
                                    </div> */}
                                {/* </div> */}
                            </div>
                            <div>
                                <ProgressReport legends={props.legends} step={props.stepCount - 2} />
                            </div>
                            {reportType == 0 ?
                                <div className='report-tabview supervisor-tabview'>
                                    <Tab.Container
                                        defaultActiveKey={activeTab}
                                        onSelect={handleTabSelect}
                                    >
                                        <div className='tab-filter-container'>
                                            <Nav as="ul" className="nav-pills mb-4 light">
                                                {tabData.map((data, i) => (
                                                    <Nav.Item as="li" key={i}>
                                                        <Nav.Link eventKey={data.id}>
                                                            {data.name}
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                ))}
                                            </Nav>
                                            <div className="form-group card-filter-select">
                                                <div className="select-drop-down">
                                                    <span><i class="fa fa-angle-down"></i></span>
                                                    <select
                                                        defaultValue={"option"}
                                                        className="form-control select-control"
                                                        value={captureType}
                                                        onChange={(e) => onFilterGeneratedReport(e.target.value)}
                                                    >
                                                        <option value="0">All</option>
                                                        <option value="1">Real time</option>
                                                        <option value="2">Manual</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <Tab.Content className="">
                                            {tabData.map((data, i) => (
                                                <Tab.Pane
                                                    eventKey={data.id}
                                                    key={i}
                                                >
                                                    {activeTab === data.id && data.content}
                                                </Tab.Pane>
                                            ))}
                                        </Tab.Content>
                                    </Tab.Container>
                                </div> :
                                <>
                                    <div className='tab-filter-container mt-4 mb-3'>
                                        <div></div>
                                        <div className="form-group card-filter-select">
                                            <div className="select-drop-down">
                                                <span><i class="fa fa-angle-down"></i></span>
                                                <select
                                                    defaultValue={"option"}
                                                    className="form-control select-control"
                                                    value={captureType}
                                                    onChange={(e) => onFilterGeneratedReport(e.target.value)}
                                                >
                                                    <option value="0">All</option>
                                                    <option value="1">Real time</option>
                                                    <option value="2">Manual</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    {cardList.map((item, index) => {
                                        return (
                                            <GenerateTimeCard
                                                key={index}
                                                //changeHandler={(value, childIndex, timesIndex) => onChangeHandler(index, value, childIndex, timesIndex)}
                                                //changeRateHandler={(value) => onChangeRateHandler(index, value)}
                                                note={false}
                                                isEdit={false}
                                                isConfig={weeklyOff}
                                                isLink={true}
                                                projectName={projectName}
                                                getTimeDetails={(weeksIndex, timeIndex, task_id) => onTimeDetails(task_id, index, weeksIndex, timeIndex, 0)}
                                                details={item} />
                                        )
                                    })}
                                </>}
                            <div style={{ marginTop: 40 }}>
                                <LeaveCardView
                                    generateReport={{}}
                                    {...leaveCardProps} />
                            </div>
                        </>
                        :
                        <div className='text-center mt-3'><h3>No Data Found</h3></div>}
                    {status == 1 ?
                        <div className='mt-4'>
                            <textarea className='form-control' placeholder='Enter Comment' value={comment} onChange={(e) => setComment(e.target.value)} />
                            {errorComment && <div className="text-danger fs-12">{errorComment}</div>}
                            {/* <div className='modal-commment'>
                            <Button
                                variant="success"
                                onClick={() => onSendBackHandler(status - 1)}>
                                Submit{" "}
                                {loading && loadingStatus == 1 ?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    : null}
                            </Button>
                            <Button variant="secondary" onClick={() => setCommentModal(false)}>
                                Cancel
                            </Button>
                        </div> */}
                        </div> : null}
                </Modal.Body>
                <Modal.Footer>
                    {status == 1 ?
                        <>
                            <button
                                className="save-submit-btn"
                                onClick={() => onStatusHandler(2)}>
                                Approve {" "}
                                {loading && loadingStatus == 2 ?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    : null}
                            </button>
                            <button
                                className="save-submit-btn"
                                //className='sendback_btn'
                                // style={{ background: '##f0a901' }}
                                onClick={() => onSendBackHandler(status - 1)}
                            >
                                Send Back{" "}
                                {loading && loadingStatus == 1 ?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    : null}
                            </button></> : null}
                    <button className="close-btn" onClick={() => setAddModal(false)}>
                        Close
                    </button>
                </Modal.Footer>
            </Modal>

            {/* <Modal
                className="fade bd-example-modal-sm"
                size="md"
                show={commentModal}
                onHide={() => setCommentModal(false)}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title><h4>Comment</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <textarea className='form-control' placeholder='Enter comment' value={comment} onChange={(e) => setComment(e.target.value)} />
                        {errorComment && <div className="text-danger fs-12">{errorComment}</div>}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="success"
                        onClick={() => onSendBackHandler(status - 1)}>
                        Submit
                    </Button>
                    <Button variant="secondary" onClick={() => setCommentModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal> */}

            <Modal
                className="fade bd-example-modal-sm"
                size="xl"
                show={timeModal}
                onHide={() => setTimeModal(false)}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title><h2>Time Track Details</h2></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {props.drillList.length > 0 ?
                        <>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>
                                            <strong>Client Name</strong>
                                        </th>
                                        <th>
                                            <strong>Employee Name</strong>
                                        </th>
                                        <th>
                                            <strong>Activity</strong>
                                        </th>
                                        <th>
                                            <strong>Task</strong>
                                        </th>
                                        <th>
                                            <strong>Duration</strong>
                                        </th>
                                        <th><strong>Date</strong></th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        props.drillList.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{item.client_first_name} {item.client_last_name}</td>
                                                    <td>{item.user_first_name} {item.user_last_name}</td>
                                                    <td>{item.activity}</td>
                                                    <td>{item.task}</td>
                                                    <td>{item.time_difference}</td>
                                                    <td><Moment format="D MMM YYYY" withTitle>{item.start_date}</Moment> to <Moment format="D MMM YYYY" withTitle>{item.end_date}</Moment></td>
                                                </tr>
                                            );
                                        })
                                    }
                                </tbody>
                            </Table>
                        </>
                        :
                        <div className="nodata-found-view">
                            <h2>Data not found</h2>
                            <p>Report data is empty or Try again search</p>
                            <button type="button"
                            //onClick={onCleanHandler}
                            >
                                Retry
                            </button>
                        </div>
                    }
                    <div className="pagination-container">
                        {parseInt(props.drillTotalRecord) > 0 && props.showLoading == false ? (
                            <div className="page-result alignResult">
                                <p>Showing{" "}{(drill.page - 1) * drill.perPage + 1 + " - " + ((drill.page - 1) * drill.perPage + props.drillList.length) + " of " + "( " + props.drillTotalRecord + " items )"}</p>
                            </div>
                        ) : (
                            <div></div>
                        )}

                        {parseInt(props.drillTotalRecord) > drill.perPage ? (
                            <ReactPaginate
                                containerClassName="pagination-gutter false pagination-circle pagination"
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                breakLabel="..."
                                nextLabel={<i class="fa fa-angle-right" aria-hidden="true"></i>}
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                previousLabel={<i class="fa fa-angle-left" aria-hidden="true"></i>}
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                renderOnZeroPageCount={null}
                                activeClassName="active"
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={3}
                                pageCount={props.drillTotalPage}
                                //initialPage={active - 1}
                                forcePage={drill.page - 1}
                            />
                        ) : null}
                    </div>
                </Modal.Body>
                <Modal.Footer>

                    <Button variant="secondary" onClick={() => setTimeModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <RightSideModal
                showModal={isComment}
                userId={userId}
                setShowModal={() => setIsComment(false)}
            />

            <Modal
                className="fade bd-example-modal-sm"
                size="md"
                show={isText}
                onHide={() => setIsText(false)}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title><h4>Comment</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <h5>{itemDetails}</h5>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setIsText(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        screenVisible: state.timeCard.screenVisible,
        showLoading: state.clients.showLoading,
        clientList: state.clients.clientList,
        projectList: state.project.projectList,
        activitiesList: state.project.activitiesList,
        taskList: state.project.taskList,
        countryList: state.country.countryList,
        timeCardDetails: state.timeCard.generatedDetails,
        totalPage: state.timeCard.totalPage,
        totalRecord: state.timeCard.totalRecord,
        configDetails: state.systemconfig.configDetails,
        systemAdmin: state.auth.systemAdmin,
        projectDetails: state.project.projectDetails,
        userId: state.auth.userId,
        employeeList: state.employee.employeeList,
        drillList: state.timeCard.drillList,
        drillTotalPage: state.timeCard.drillTotalPage,
        drillTotalRecord: state.timeCard.drillTotalRecord,
        pendingCount: state.timeCard.pendingCount,
        stepCount: state.timeCard.stepCount,
        legends: state.timeCard.legends,
    };
};
export default connect(mapStateToProps)(SuperVisorApprover);